// material-ui

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const HookoffIcon = ({ color = '#3B66B0', width = 22, className = 'abc' }) => {
    

    return (
        <svg
          width={width}
          height={width}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >          
          <path 
          fill={color}
          d="M17.9,5c-0.5-2.2-2.7-3.4-4.9-2.9C10.9,2.7,9.6,4.8,10.1,7c0.4,1.4,1.5,2.5,2.9,2.9v1.3v5.1V17c0,1.7-1.3,3-3,3
	s-3-1.3-3-3h3l-5-5v5c0,2.3,1.6,4.3,3.8,4.8c2.5,0.6,5.2-1,6-3.7c0-0.2,0.1-0.3,0.1-0.6c0-0.2,0-0.5,0.1-0.6v-3.7V9.9
	C17.1,9.3,18.4,7.1,17.9,5z M14,8c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S15.1,8,14,8z"/>
        </svg>
      );
};

export default HookoffIcon;
